import React from 'react'
import { isFeatureEnabled } from '~/app/utils/feature-flag'
import LegacyCartPage from '~/app/components/Cart/LegacyCartPage'
import CartPage from '~/app/components-nds/domestic/cart/cart-page'
import getServerSideViewerInfo from '~/app/utils/getServerSideViewerInfo'
import { fetchExpInfo } from '~/app/react-query/common/expInfo'
import { QueryClient } from '@tanstack/react-query'
/**
 * Cart Page - Feature Flag Based Routing
 * description: feature flag를 사용해 구/신 장바구니 페이지를 분기
 */
type ServerSideProp = Await<ReturnType<typeof getServerSideProps>>
const Index = ({ viewer, pageType }: ServerSideProp['props']) => {
  if (pageType === 'new') {
    return <CartPage viewer={viewer} />
  }

  return <LegacyCartPage viewer={viewer} />
}

export async function getServerSideProps(ctx) {
  const useNewCartPage = isFeatureEnabled('newCartPage')

  const { viewer } = await getServerSideViewerInfo(ctx)

  // 실험군 체크
  const queryClient = new QueryClient()
  const { expMeta } = await fetchExpInfo(
    {
      organization: 'NolCartNewDesignsystem',
      featureId: 'NolCartNewDesignsystem',
      expSpecifier: ctx.req.headers.cgntId || ctx.req.cookies.cgntId || '',
    },
    queryClient
  ).catch(() => ({ expMeta: { expGroup: 'NOLCARTNEWDESIGNSYSTEM_A' } }))
  const isNewCartCBT = expMeta.expGroup === 'NOLCARTNEWDESIGNSYSTEM_B'

  if (useNewCartPage && isNewCartCBT) {
    // 신규 페이지
    return {
      props: {
        viewer,
        pageType: 'new' as const,
      },
    }
  }

  // 구 페이지
  return {
    props: {
      viewer,
      pageType: 'legacy' as const,
    },
  }
}

export default Index
